<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
        <template v-if="this.user_id === undefined && parseInt(context.$store.state.config.user.level) < 99">
        <p class="control is-expanded">
          <label class="label">Customer</label>
          <v-select v-model="user.agency" :options="getCustomers()" class="is-fullwidth" max-height="200px"></v-select>
        </p>
        </template>
        <template v-else-if="parseInt(context.$store.state.config.user.level) < 99">
          <p class="control is-expanded">
            <label class="label">Customer</label>
            <input :class="{'input': true, 'is-disabled': true}" type="text" name="agency_name" id="agency_name" v-model="user.agency_name">
          </p>
        </template>
        <template>
          <p class="control">
            <label class="label">Name</label>
            <input :class="{'input': true, 'is-danger': errors.has('name'), 'is-disabled': inProgress}" type="text" name="name" id="name" placeholder="Name" v-model="user.name" v-validate="'required'">
            <span v-show="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</span>
          </p>
          <p class="control">
            <label class="label">Email</label>
            <input :class="{'input': true, 'is-danger': errors.has('email'), 'is-disabled': inProgress || this.user_id !== undefined }" type="email" name="email" id="email" placeholder="Email" v-model="user.email" v-validate="'required|email'">
            <span v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</span>
          </p>
          <p class="control">
            <label class="label">Password</label>
            <input :class="{'input': true, 'is-danger': errors.has('password'), 'is-disabled': inProgress, 'password': true}" type="password" name="password" id="password" placeholder="Password" v-model="user.password" v-validate="'required'">
            <span v-show="errors.has('password')" class="help is-danger">{{ errors.first('password') }}</span>
          </p>
          <p class="control">
            <label class="checkbox">
              <input type="checkbox" v-model="user.admin">
              Admin
            </label>
          </p>
          <p class="control">
            <label class="checkbox">
              <input type="checkbox" v-model="user.active">
              Active
            </label>
          </p>
          <p class="control" v-if="canEditHide">
            <label class="checkbox">
              <input type="checkbox" v-model="hideUser">
              Hide
            </label>
          </p>
        </template>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a :class="{'button': true, 'is-primary': true, 'is-disabled': inProgress}" @click="close(true)">Close</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true, 'is-disabled': errors.any(), 'is-loading': inProgress}" @click="save">Save</a>
          </p>
        </div>
      </footer>
    </div>
  </div>

</template>

<script>
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'
  export default {
    props: {
      context: {
        type: Object
      },
      callback: {
        type: String
      },
      title: {
        type: String
      },
      user_id: {
        type: Number
      }
    },
    data () {
      return {
        user: {
          name: '',
          email: '',
          password: '',
          agency: '',
          agency_name: '',
          admin: false,
          active: 0,
          status: 0
        },
        inProgress: false,
        error: '',
        agencies: []
      }
    },
    mounted () {
      this.$nextTick(() => {
        if (this.user_id) {
          this.loadData()
        } else {
          document.body.appendChild(this.$el)
          if (parseInt(this.context.$store.state.config.user.level) < 99) {
            this.loadCustomers()
          }
        }
      })
    },
    methods: {
      loadData () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/users/' + this.user_id).then((response) => {
          this.$validator.detach('password')
          this.user = response.body
          this.user.admin = !!response.body.admin
          this.user.active = Number(response.body.active)
          this.user.status = Number(response.body.status || 0)
          this.user.agency = response.body.agency_id
          document.body.appendChild(this.$el)
        }, (response) => {
        })
      },
      loadCustomers () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/agencies/all').then((response) => {
          this.agencies = response.body
        }, (response) => {

        })
      },
      getCustomers () {
        let customers = []
        customers.push({label: 'All', value: ''})
        for (var i = 0; i < this.agencies.length; i++) {
          customers.push({label: this.agencies[i].name, value: this.agencies[i].id})
        }
        customers.sort(function (a, b) {
          if (a.label < b.label) {
            return -1
          }
          if (a.label > b.label) {
            return 1
          }
          return 0
        })
        return customers
      },
      close (closeOnly, result) {
        if (!closeOnly) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      save () {
        if (window.confirm('Are you sure you want to save the changes?')) {
          this.$validator.validateAll().then(() => {
            this.inProgress = true
            this.error = ''
            let url = this.context.$store.state.config.apiURL + '/users/account'
            if (this.user_id) {
              url = this.context.$store.state.config.apiURL + '/users/account/' + this.user_id
            }
            this.context.$http.post(url, this.user).then((response) => {
              this.inProgress = false
              this.close(false, {
                ok: true,
                message: 'The client ' + this.user.name + ' was successfully save'
              })
            }, (response) => {
              this.inProgress = false
              this.error = response.body
            })
          }).catch(() => {

          })
        }
      },
      clearAccount () {
        this.user.agency = ''
        this.user.agency_name = ''
        this.inProgress = false
        this.error = ''
      }
    },
    components: {
      vSelect
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      },
      canEditHide () {
        const level = parseInt(this.context.$store.state.config.user.level)
        const active = Number(this.user.active)
        return active === 0 && level < 99
      },
      hideUser: {
        get () {
          return this.user.status === 0
        },
        set (value) {
          this.user.status = value ? 0 : 1
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }

  .panel {
    background-color: white;
    box-shadow: 0 2px 3px rgb(167, 28, 32), 0 0 0 1px rgb(167, 28, 32);
    color: #4a4a4a;
    max-width: 100%;
    position: relative;
    border: 0;
    border-radius: 0;
  }

  .panel-heading {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0 1px 0 rgb(167, 28, 32), 0 0 0 0 rgb(167, 28, 32);
    background-color: rgb(167, 28, 32);
    border-bottom: 0;
    border-radius: 0;
    font-size: 1rem;
  }
</style>



// WEBPACK FOOTER //
// Client.vue?51786f6a